interface IRatingTotal {
    totalAverageStars: number;
    totalReviews: number;
    categories: IRatingCategory[];
}

interface IRatingCategory {
    title: string;
    averageStars: number;
    reviews: number;
}

module Bookhus.Widgets.DisplayRatings {
    var translations = {
        reviews: {
            'da': 'anmeldelser',
            'en-GB': 'reviews',
            'no': 'anmeldelser',
            'sv': 'recensioner',
            'de': 'Bewertungen'
        },
        get: function (name: string, lang?: string) {

            if (this[name] == undefined || this[name] == null) {
                return "Oversættelse findes ikke";
            }

            var langCode = $.datepicker.regional.bookhuscurrent as string;
            if (lang != undefined && lang != null) {
                langCode = lang;
            }

            var value = this[name][langCode] || this[name]["da"];
            if (value == undefined || value == "") {
                return "Oversættelse findes ikke";
            }
            return value;
        }
    }

    var cachedRequests: { [key: string]: JQueryXHR } = {};


    export function runDisplayRatings(context?: JQuery) {
        var $context = context && context.length ? context : $(document);
        var $ratings = $context.find('[data-toggle="userrating"]');
        if ($context.is('[data-toggle="userrating"]')) {
            $ratings = $ratings.add($context[0]);
        }

        $ratings.filter(':not([data-rating-initialized])').each((index, element) => {
            var $element = $(element);
            $element.attr('data-rating-initialized', 'true');
            var houseId = $element.data('houseid');

            if (houseId <= 0) {
                return;
            }

            var url = `/api/widgets/gethouserating?houseId=${houseId}`;
            if (cachedRequests[url]) {
                cachedRequests[url].then((result: IRatingTotal) => {
                    displayRating(result, $element);
                });
            }
            else {
                var xhr = $.getJSON(url, (result: IRatingTotal) => {
                    displayRating(result, $element);
                });
                cachedRequests[url] = xhr;
            }
        });
    }

    function displayRating(rating: IRatingTotal, target: JQuery) {
        var rounded = Math.round(rating.totalAverageStars);
        target.find(`.userRating .fa.fa-star:nth-child(-n+${rounded})`).addClass('checked');

        if (!rating.totalReviews) {
            rating.totalReviews = 0;
            if (rating.categories != null && rating.categories != undefined) {
                rating.totalReviews = rating.categories.reduce((sum, current) => sum + current.reviews, 0);
            }
        }

        target.children('.subText').text(`${rating.totalReviews} ${translations.get("reviews")}`);

        if (rounded > 0) {
            target.attr('role', 'button');
            target.on('click', () => {
                if (!rating || !rating.categories) {
                    return;
                }

                var listContent = "";
                for (var i = 0; i < rating.categories.length; i++) {
                    var current = rating.categories[i];
                    var rounded = Math.round(current.averageStars);
                    listContent += `
                    <li class="list-group-item d-flex flex-column justify-content-between align-items-start">
                        <span class="text-left">${current.title}</span>
                        <span class="userRating d-inline-block">
                            <span class="fa fa-star ${rounded > 0 ? 'checked' : ''}"></span>
                            <span class="fa fa-star ${rounded > 1 ? 'checked' : ''}"></span>
                            <span class="fa fa-star ${rounded > 2 ? 'checked' : ''}"></span>
                            <span class="fa fa-star ${rounded > 3 ? 'checked' : ''}"></span>
                            <span class="fa fa-star ${rounded > 4 ? 'checked' : ''}"></span>
                        </span>
                    </li>
                `;
                }
                swal.fire({
                    position: 'top',
                    title: 'Bedømmelser',
                    html: `
                    <ul class="list-group list-group-flush">
                        ${listContent}
                    </ul>
                `,
                    width: '100%',
                    showClass: {
                        popup: 'swal2-fade-show'
                    },
                    hideClass: {
                        popup: 'swal2-fade-hide'
                    },
                    customClass: {
                        popup: 'swal-lg'
                    }
                });
            });
        }
    }
}

$(function () {
    Bookhus.Widgets.DisplayRatings.runDisplayRatings();
});
